import type { UserResponse } from "@/api";

export type UserRole = "member" | "platform_admin" | "install_admin";
export type UserStatus = "active" | "pending" | "deactivated";

export const USER_ROLES: readonly UserRole[] = ["member", "platform_admin", "install_admin"];

/** Deactivated wins; an active user who has never signed in is "pending". */
export function userStatus(user: Pick<UserResponse, "isActive" | "lastLoginAt">): UserStatus {
  if (!user.isActive) return "deactivated";
  return user.lastLoginAt ? "active" : "pending";
}

/**
 * Mirrors the backend's check_user_update_permissions: nobody edits
 * themselves, and only install admins touch install admins.
 */
export function canManageUser(
  target: Pick<UserResponse, "uuid" | "role">,
  me: { uuid: string; role: string },
): boolean {
  if (target.uuid === me.uuid) return false;
  return target.role !== "install_admin" || me.role === "install_admin";
}

/** Only install admins can grant install_admin. */
export function assignableRoles(meRole: string): UserRole[] {
  return meRole === "install_admin" ? [...USER_ROLES] : USER_ROLES.filter((r) => r !== "install_admin");
}

/** Only deactivated users who never signed in (e.g. a mistyped pre-provisioned email) can be deleted. */
export function canDeleteUser(user: Pick<UserResponse, "isActive" | "lastLoginAt">): boolean {
  return !user.isActive && !user.lastLoginAt;
}
